import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';

type Props = {
    todoText: string;
    buttonText: string;
    onClick: () => void;
};

export function NeedToConfigureEmptyState(props: Props) {
    return (
        <div className='full-height flex flex-dir-col justify-center'>
            <EmptyStateLarge
                icon={<Illustration src='www-lady' width={280} />}
                cta={
                    <Button size='xlarge' variant='primary' onClick={props.onClick}>
                        {props.buttonText}
                    </Button>
                }
                title='Almost there! One more step to get started…'
                subtitle={props.todoText}
            />
        </div>
    );
}
